import { createFileRoute } from '@tanstack/react-router';

import { WhatsAppSettingsPage } from '@/features/whatsapp/pages/WhatsAppSettingsPage';

export const Route = createFileRoute('/_app/$wsSlug/settings/whatsapp')({
  component: WhatsAppSettingsPage,
});
